import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';

import { ScoutingCenter } from 'components/scoutingCenter/stats/ScoutingCenter';

const ScoutingCenterPage = () => {
  return (
    <>
      <PageHeader text={scoutingCenter.scout} disableBackBrowser />
      <ScoutingCenter />
    </>
  );
};
export default ScoutingCenterPage;
